// Importing the AlbumForm component for editing an album
import AlbumForm from "./AlbumForm";

// Functional component EditAlbum
const EditAlbum = () => {
  
  // Rendering the AlbumForm component for editing an album
  return <AlbumForm />;
};

// Exporting EditAlbum as the default export
export default EditAlbum;
